<div class="dialog-stretch">

  <!-- HEADER -->
  <div class="d-flex justify-content-between pt-2"
    mat-dialog-title>
    <h2 class="mb-0 mat-headline-6  w-100 d-flex align-items-center">{{'SALE.ADD_ITEMS' | translate}}</h2>
    <button mat-icon-button
      (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="py-2">
    <form [formGroup]="form"
      (submit)="onSave()">
      <mat-form-field appearance="outline"
        class="w-100">
        <mat-label>{{'COMMON.LABEL.SALE' | translate}}</mat-label>
        <input type="text"
          matInput
          formControlName="sale"
          [matAutocomplete]="auto">
        @if (form?.value.sale) {
          <button
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="onClearSaleInput()">
            <mat-icon>close</mat-icon>
          </button>
        }

        <mat-autocomplete #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="onSelectSale($event)">
          @for (sale of filteredSales; track sale) {
            <mat-option
              [value]="sale">
              ID:{{sale.id}} - {{sale.name}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
    class="d-flex align-items-center">
    <!-- ACTIONS -->
    <button mat-flat-button
      (click)="onClose()">
      {{ 'BITF.DIALOGS.BUTTON_CANCEL_TEXT' | translate }}
    </button>
    <button mat-flat-button
      color="primary"
      [disabled]="!form.valid || !this.selectedSale"
      (click)="onSave()">
      {{ 'BITF.DIALOGS.BUTTON_OK_TEXT_TO_SAVE' | translate }}
    </button>
  </mat-dialog-actions>

</div>